export default ({ request }) => ({
  orderDeductionListApi(data = {}) {
    return request({
      url: '/factory/order/deduction/list',
      method: 'post',
      data,
    })
  },
  orderDeductionSaveApi(data = {}) {
    return request({
      url: '/factory/order/deduction/save',
      method: 'post',
      data,
    })
  },
  orderDeductionDetailApi(data = {}) {
    return request({
      url: '/factory/order/deduction/detail',
      method: 'post',
      data,
    })
  },
  orderDeductionDelApi(data = {}) {
    return request({
      url: '/factory/order/deduction/del',
      method: 'post',
      data,
    })
  },
  orderDeductionSubmitAuditApi(data = {}) {
    return request({
      url: '/factory/order/deduction/submit',
      method: 'post',
      data,
    })
  },
  orderDeductionSubmitOaApplyApi(data = {}) {
    return request({
      url: '/oa/order/deduction/apply',
      method: 'post',
      data,
    })
  },
  orderDeductionItemListApi(data = {}) {
    return request({
      url: '/factory/order/deduction/item/list',
      method: 'post',
      data,
    })
  },
  orderDeductionDocistApi(data = {}) {
    return request({
      url: '/factory/order/deduction/doc/list',
      method: 'post',
      data,
    })
  },
})
